import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
const testimonials = [{
  quote: "The sonic clarity achieved in their studio is unmatched. My latest EP sounds like a major label production thanks to their futuristic mixing techniques.",
  name: "Jaxen Voids",
  role: "Electronic Producer",
  location: "Berlin, DE",
  badgeText: "Studio Session"
}, {
  quote: "Collaborating with this label changed my career trajectory. Their vision for the future of sound is exactly what the underground scene needed.",
  name: "Luna Ray",
  role: "Synth-Pop Artist",
  location: "Tokyo, JP",
  badgeText: "Global Release"
}, {
  quote: "From the first demo submission to the final master, the communication was seamless. They truly understand the digital frontier of music.",
  name: "Kaelen Smith",
  role: "Sound Designer",
  location: "London, UK",
  badgeText: "Artist Signing"
}];
export default function GetInTouch() {
  return <section data-section-id="258386" id="get-in-touch" className="bg-background text-foreground py-24">
      
    </section>;
}